import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminKYC() {
  const [items, setItems] = useState([]);
  const [view, setView] = useState(null); // selected kyc record

  const load = async () => {
    const r = await api.get("/admin/kyc/all");
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    if (!confirm("Approve this KYC?")) return;
    await api.post(`/admin/kyc/${id}/approve`);
    toast.success("Approved"); setView(null); load();
  };
  const reject = async (id) => {
    const reason = prompt("Reason for rejection:");
    if (!reason) return;
    await api.post(`/admin/kyc/${id}/reject`, { reason });
    toast.success("Rejected"); setView(null); load();
  };

  return (
    <div>
      <h1 className="font-display text-3xl mb-6">KYC Queue</h1>

      <div className="gf-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F8F4E9] text-xs uppercase tracking-wider text-[#6B5F58]">
            <tr>
              <th className="text-left px-4 py-3">Customer</th>
              <th className="text-left px-4 py-3">Phone</th>
              <th className="text-left px-4 py-3">PAN</th>
              <th className="text-left px-4 py-3">Submitted</th>
              <th className="text-left px-4 py-3">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((k) => (
              <tr key={k.id} className="border-t border-[#E8E0D2]">
                <td className="px-4 py-3">{k.user?.full_name}</td>
                <td className="px-4 py-3">{k.user?.phone}</td>
                <td className="px-4 py-3 font-mono text-xs">{k.pan_number}</td>
                <td className="px-4 py-3 text-xs">{(k.submitted_at || "").slice(0,10)}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    k.status === "approved" ? "bg-[#FCEDED] text-[#D71921]"
                    : k.status === "rejected" ? "bg-red-100 text-red-800"
                    : "bg-amber-100 text-amber-800"}`}>{k.status}</span>
                </td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => setView(k)} data-testid={`view-kyc-${k.id}`}
                    className="text-[#D71921] text-sm hover:underline">Review</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="px-4 py-12 text-center text-[#6B5F58]">No KYC submissions yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {view && (
        <div className="fixed inset-0 z-50 backdrop-blur-md bg-stone-900/40 grid place-items-center p-4 overflow-auto" onClick={() => setView(null)}>
          <div className="bg-white rounded-2xl border border-[#E8E0D2] max-w-2xl w-full p-6 my-10" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="text-xs uppercase tracking-widest text-[#6B5F58]">KYC Review</div>
                <div className="font-display text-2xl">{view.user?.full_name}</div>
                <div className="text-sm text-[#6B5F58]">{view.user?.phone} · {view.user?.email || "—"}</div>
              </div>
              <span className={`px-2 py-0.5 rounded-full text-xs ${
                view.status === "approved" ? "bg-[#FCEDED] text-[#D71921]"
                : view.status === "rejected" ? "bg-red-100 text-red-800"
                : "bg-amber-100 text-amber-800"}`}>{view.status}</span>
            </div>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <Field label="PAN" value={view.pan_number} />
              <Field label="Aadhaar" value={view.aadhaar_number} />
              <Field label="Address" value={view.address} colSpan />
            </div>
            <div className="grid grid-cols-3 gap-3 mt-4">
              {[
                ["PAN", view.pan_image_b64],
                ["Aadhaar", view.aadhaar_image_b64],
                ["Selfie", view.selfie_b64],
              ].map(([l, src]) => (
                <div key={l}>
                  <div className="text-xs text-[#6B5F58] mb-1">{l}</div>
                  {src ? <img src={src} alt={l} className="w-full h-32 object-cover rounded-lg border border-[#E8E0D2]" />
                       : <div className="w-full h-32 grid place-items-center text-xs text-[#6B5F58] rounded-lg border border-dashed border-[#E8E0D2]">No image</div>}
                </div>
              ))}
            </div>
            {view.status === "pending" && (
              <div className="flex gap-2 mt-6">
                <button onClick={() => approve(view.id)} data-testid="kyc-approve-btn"
                  className="flex-1 px-4 py-2.5 rounded-xl bg-[#D71921] text-white font-medium">Approve</button>
                <button onClick={() => reject(view.id)} data-testid="kyc-reject-btn"
                  className="flex-1 px-4 py-2.5 rounded-xl bg-white border border-red-200 text-red-700 font-medium">Reject</button>
              </div>
            )}
            {view.rejection_reason && view.status === "rejected" && (
              <div className="mt-4 text-sm bg-red-50 border border-red-200 rounded-lg p-3 text-red-800">
                <b>Reason:</b> {view.rejection_reason}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, colSpan }) {
  return (
    <div className={colSpan ? "col-span-2" : ""}>
      <div className="text-xs uppercase tracking-wider text-[#6B5F58]">{label}</div>
      <div className="text-sm mt-1">{value || "—"}</div>
    </div>
  );
}
